import upperFirst from 'lodash-es/upperFirst';
import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { ILookupApiResponse, lookupActionCreators } from '..';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* deleteLookupValueSaga(action: ReturnType<typeof lookupActionCreators.deleteLookupValue>) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response = yield* call(executeUpdate, action.payload.type, action.payload.id);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.removeLookupValue(action.payload));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteLookupValue() {
  yield takeEvery(lookupActionCreators.deleteLookupValue.match, deleteLookupValueSaga);
}

async function executeUpdate(type: keyof ILookupApiResponse, value: number) {
  return executeApiRequest(() => httpService.delete(`/Lookups/${upperFirst(type)}/${value}`), false);
}
